module.exports = __webpack_public_path__ + "static/media/shoes.af83500e.jpg";